let nextPasswordId = 0;

/** Visibility is temporary UI state; never copy credentials into storage or a URL. */
export function bindPasswordVisibility(root: ParentNode): void {
  root.querySelectorAll<HTMLInputElement>('input[type="password"]').forEach(input => {
    if (input.dataset.visibilityBound) return;
    input.dataset.visibilityBound = "true";
    const doc = input.ownerDocument;
    const label = input.getAttribute("aria-label") || input.closest("label")?.firstChild?.textContent?.trim() || "Password";
    input.setAttribute("aria-label", label);
    input.id ||= `password-field-${++nextPasswordId}`;
    const wrapper = doc.createElement("span"); wrapper.className = "password-control";
    input.before(wrapper); wrapper.append(input);
    const button = doc.createElement("button"); button.type = "button"; button.className = "text-button password-visibility";
    button.setAttribute("aria-controls", input.id); button.setAttribute("aria-pressed", "false");
    const refresh = () => { const shown = input.type === "text"; button.textContent = shown ? "Hide" : "Show"; button.setAttribute("aria-label", `${shown ? "Hide" : "Show"} ${label.toLowerCase()}`); button.setAttribute("aria-pressed", String(shown)); button.disabled = input.disabled; };
    button.addEventListener("click", () => { input.type = input.type === "password" ? "text" : "password"; refresh(); });
    wrapper.append(button); refresh();
  });
}
